/************************************************************************
** IBM Confidential
**
** IBM Business Analytics: Rapidly Adaptive Visualization Engine
**
** (C) Copyright IBM Corp. 2017, 2020
**
** The source code for this program is not published or otherwise divested of its trade secrets, 
** irrespective of what has been deposited with the U.S. Copyright Office.
************************************************************************/
/**
 * This class is used to properly translate String.codePoints()
 */
export default class CodePointIterator
{
    _str = "";
    _cur = 0;

    constructor(str)
    {
        this._str = str;
    }

    iterator()
    {
        return this;
    }

    hasNext()
    {
        return this._cur < this._str.length;
    }

    nextInt()
    {
        if (this._cur  >= this._str.length) 
        {
            return undefined;
        }

        // Get the first code unit
        var first = this._str.charCodeAt(this._cur++);
        // check if it's the start of a surrogate pair
        if (first >= 0xD800 && first <= 0xDBFF && // high surrogate
            this._cur < this._str.length) // there is a next code unit
        {
            var second = this._str.charCodeAt(this._cur);
            if (second >= 0xDC00 && second <= 0xDFFF) 
            { 
                // low surrogate
                this._cur++;
                return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
            }
        }
        return first;
    }
}


// WEBPACK FOOTER //
// ./src/generated/CodePointIterator.js